import "./ExperienceDetail.scss";

const VertuMotorsTechLead = () => {
  return (
    <div className="experience-detail">
      <div className="experience-detail__container">
        <div className="experience-detail__header">
          <span className="experience-detail__tenure">
            November 2022 - August 2023
          </span>
          <h1 className="experience-detail__title">
            Technical Lead at Vertu Motors
          </h1>
        </div>

        <div className="experience-detail__content">
          <section className="experience-detail__section">
            <h2>Overview</h2>
            <p>
              During my time at Vertu Motors I became a Technical Lead, in which
              I led a team through the process of developing a greenfield app
              from start to finish.
            </p>
          </section>

          <section className="experience-detail__section">
            <h2>Responsibilities</h2>
            <ul>
              <li>
                Leading a development team through the full lifecycle of a
                greenfield application
              </li>
              <li>Making architectural decisions and technology choices</li>
              <li>Mentoring junior developers and conducting code reviews</li>
              <li>
                Coordinating with stakeholders to define requirements and
                deliverables
              </li>
              <li>
                Establishing development practices and standards for the team
              </li>
            </ul>
          </section>

          <section className="experience-detail__section">
            <h2>Tech Stack</h2>
            <div className="experience-detail__tags">
              <span className="experience-detail__tag">React</span>
              <span className="experience-detail__tag">Angular</span>
              <span className="experience-detail__tag">TypeScript</span>
              <span className="experience-detail__tag">SCSS</span>
            </div>
          </section>
        </div>

        <a href="/" className="experience-detail__back-link">
          ← Back to Portfolio
        </a>
      </div>
    </div>
  );
};

export default VertuMotorsTechLead;
